const initials = "checkerList/";
export const UPDATE_CHECKER_LIST = `${initials}UPDATE_CHECKER_LIST`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;
export const UPDATE_SINGLE_CHECKER = `${initials}UPDATE_SINGLE_CHECKER`;
